import axios from "axios";

export var api = {
    data() {
        return {
            endpoints: {
                frameworkAuthentication: "/user/login",

                getFlaps: "/process/getFlaps",
                getProcess: "/process/getProcess",
                doProcess: "/process/doProcess",
                getCatalog: "/process/getCatalog",
                getDictionary: "/process/getDictionary",
                getQuery: "/process/getQuery",
                downloadQuery: "/process/downloadQuery",
                uploadQuery: "/process/uploadQuery",
                doProcessFile: "/process/doProcessFile",
                doQueryFile: "/process/doQueryFile",

                getOnboardings: "/process/getOnboardings",
                getMenu: "/process/getMenu",
                getApplications: "/process/getApplications",
                getApplication: "/process/getApplication",
                getGeneral: "/process/getGeneral",
                getGeneralApplication: "/process/getGeneralApplication",
                getExternal: "/process/getExternal",
            },
        };
    },
    methods: {
        enrichUrl({ id, path, params }) {
            let result = this.environment.endpoint.urlBack + this.endpoints[id];
            if (path) {
                Object.keys(path)
                    .filter((pf) => path[pf])
                    .forEach((pf) => {
                        result += "/" + /*pf + "/" +*/ path[pf];
                    });
            }
            if (params) {
                const paramsList = Object.keys(params)
                    .filter((field) => params[field])
                    .map((field) => field + "=" + params[field]);
                result += "?" + paramsList.join("&");
            }
            return result;
        },

        apiHeaders(applicationName, method, actionType) {
            let session = this.loadSession(applicationName);
            if (!session || !session.loggedIn) {
                session = this.loadSession();
            }
            const language = this.currentLanguage();
            let headers = {
                "process-application": applicationName ? applicationName : "",
                "process-method": method ? method : "get",
                "process-language": language,
                "process-action-type": actionType ? actionType : "general",
            };
            
            if (session.details) {
                headers["process-token"] = session.details.token;
                headers["process-user"] = session.details.userName;
            }
            Object.keys(session.details)
                .filter(key => !['token', 'userName', 'changePassword', 'fullName', 'initials', 'jwt', 'roles'].includes(key))
                .forEach(key => {
                    headers["process-custom-field-" + key] = session.details[key];
                })
            const frameworkSession = this.loadFrameworkSession();
            if (frameworkSession && frameworkSession.authenticated) {
                headers["Authorization"] = "Bearer " + frameworkSession.token;
                headers["process-framework-token"] = frameworkSession.token;
            }
            return headers;
        },

        apiHeadersExternal() {
            const frameworkSession = this.loadFrameworkSession();
            let headers = {};
            if (frameworkSession && frameworkSession.authenticated) {
                headers["Authorization"] = "Bearer " + frameworkSession.token;
                headers["process-framework-token"] = frameworkSession.token;
            }
            return headers;
        },

        apiLoadProcess({ headers, path, body }) {
            const url = this.enrichUrl({ id: "getProcess", path });
            const defHeaders = this.apiHeaders(
                this.applicationName,
                headers.method,
                headers.actionType
            );

            return axios.post(url, body, { headers: defHeaders });
        },

        apiLoadCatalog({ path, body }) {
            const url = this.enrichUrl({ id: "getCatalog", path });
            const headers = this.apiHeaders(this.applicationName);
            const finalBody = body ?? {};
            return axios.post(url, finalBody, { headers });
        },

        apiLoadDictionary({ path, body }) {
            const url = this.enrichUrl({ id: "getDictionary", path });
            const headers = this.apiHeaders(this.applicationName);
            const finalBody = body ?? {};
            return axios.post(url, finalBody, { headers });
        },

        apiLoadQuery({ path, params, body }) {
            const url = this.enrichUrl({
                id: "getQuery",
                path,
                params,
            });

            const headers = this.apiHeaders(this.applicationName);
            return axios.post(url, body, { headers });
        },

        apiDownloadQuery({ path, params, body }) {
            const url = this.enrichUrl({
                id: "downloadQuery",
                path,
                params,
            });

            const headers = this.apiHeaders(this.applicationName);
            return axios.post(url, body, { headers });
        },

        apiUploadQuery({ path, body }) {
            const url = this.enrichUrl({ id: "uploadQuery", path });
            const headers = this.apiHeaders(this.applicationName);
            return axios.post(url, body, { headers });
        },

        apiDoProcess({ headers, path, body }) {
            const url = this.enrichUrl({ id: "doProcess", path });
            const defHeaders = this.apiHeaders(
                this.applicationName,
                headers.method ?? "post"
            );
            return axios.post(url, body, { headers: defHeaders });
        },

        apiLoadOnboardings({ path }) {
            const url = this.enrichUrl({ id: "getOnboardings", path });
            const headers = this.apiHeaders(this.applicationName);
            return axios.get(url, { headers });
        },

        apiLoadMenus({ path, body }) {
            const url = this.enrichUrl({ id: "getMenu", path });
            const headers = this.apiHeaders(this.applicationName);
            return axios.post(url, body, { headers });
        },

        apiGetApplications({ body }) {
            const url = this.enrichUrl({ id: "getApplications" });
            const headers = this.apiHeaders();
            return axios.post(url, body, { headers });
        },

        apiGetGeneral() {
            const url = this.enrichUrl({ id: "getGeneral" });
            const headers = this.apiHeaders();
            return axios.get(url, { headers });
        },

        apiGetGeneralApplication({ path }) {
            const url = this.enrichUrl({ id: "getGeneralApplication", path });
            const headers = this.apiHeaders();
            return axios.get(url, { headers });
        },

        apiGetFlaps({ path }) {
            const url = this.enrichUrl({ id: "getFlaps", path });
            const headers = this.apiHeaders(this.applicationName);
            return axios.get(url, { headers });
        },
        apiGetExternal({ path }) {
            const url = this.enrichUrl({ id: "getExternal", path });
            const headers = this.apiHeadersExternal();
            return axios.get(url, { headers });
        },

        apiGetApplication({ path }) {
            const url = this.enrichUrl({ id: "getApplication", path });
            const headers = this.apiHeaders(this.applicationName);
            return axios.get(url, { headers });
        },

        apiDoProcessFile({ path, body }) {
            const url = this.enrichUrl({ id: "doProcessFile", path });
            let headers = this.apiHeaders(this.applicationName);
            return axios.post(url, body, { headers });
        },

        apiDoQueryFile({ path, body }) {
            const url = this.enrichUrl({ id: "doQueryFile", path });
            let headers = this.apiHeaders(this.applicationName);
            return axios.post(url, body, { headers });
        },

        getArrayTranApiSuccess(trans) {
            let result = true;
            trans.forEach((tran) => {
                if (!this.getApiSuccess(tran.data)) {
                    result = false;
                }
            });
            return result;
        },

        getArrayTranApiMessages(trans, error) {
            let result = [];
            trans.forEach((tran) => {
                result.push(this.getApiMessages(tran.data, error));
            });
            return result;
        },

        getTranApiSuccess(tran) {
            return this.getApiSuccess(tran.apiResponse);
        },

        getTranApiData(tran) {
            return this.getApiData(tran.apiResponse);
        },

        getTranApiAuthentication(tran) {
            return tran.authentication;
        },

        getTranApiMessages(tran, error) {
            return this.getApiMessages(tran.apiResponse, error);
        },

        getTranApiMessagesEx(tran, error, ext) {
            const messages = this.getTranApiMessages(tran, error);
            return messages.length > 0 && this.notBlank(messages[0])
                ? messages
                : [ext];
        },

        getApiSuccess(apiResponse) {
            return apiResponse.success;
        },

        getApiData(apiResponse) {
            return apiResponse.data;
        },

        apiExceptions(apiResponse, generalExApplicationEx) {

            if (!this.emptyObject(apiResponse)) {
                if (!apiResponse.succes) {
                    switch (apiResponse.status) {
                        case 403: {
                            const applicationName = generalExApplicationEx.applicationEx.application.name;
                            this.goToLogin(applicationName);
                            break;
                        }
                    }
                }
            }

        },

        tranApiExceptions(tran, generalExApplicationEx) {
            this.apiExceptions(tran.apiResponse, generalExApplicationEx);
        },

        getApiMessages(apiResponse, error) {
            let result = error
                ? apiResponse.errorMessages
                : apiResponse.infoMessages;
            return result ? result : [];
        },

        apiFrameworkAuthentication({ body }) {
            const url = this.enrichUrl({ id: "frameworkAuthentication" });
            return axios.post(url, body);
        },
    },
};
